import type { Bot } from '@/api/schema'
import { Motion } from '@/app/components/Motion/Motion'
import { ChatOfferV2 } from '@/app/components/OfferV2/ChatOfferV2'
import ArrowRightSvg from '@/app/icons/arrow-right.svg?react'
import CloseSvg from '@/app/icons/close.svg?react'
import MenuBtnSvg from '@/app/icons/menu-btn.svg?react'
import { ChatMenu } from '@/app/pages/ChatPage/ChatFooter/ChatMenu/ChatMenu'
import { useChat } from '@/app/state/chat'
import { useChatMenu } from '@/app/state/chatMenu'
import { useSession } from '@/app/state/session'
import { metrikaGoal } from '@/app/utils/metrika'
import type { FunctionalComponent } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import { useShallow } from 'zustand/shallow'
import styles from './index.module.scss'

export const ChatFooter: FunctionalComponent<{
  bot?: Bot
}> = props => {
  const user = useSession(useShallow(s => s.user))
  const chatSubmit = useChat(s => s.submit)
  const processing = useChat(s => s.processing)
  const retryText = useChat(s => s.retryText)
  const hideChatMenu = useChatMenu(s => s.hide)
  const showChatMenu = useChatMenu(s => s.show)
  const setGroupId = useChatMenu(s => s.setGroupId)
  const messageCount = useSession(s => s.user?.messagesCount)
  const chatMenuVisible = useChatMenu(s => s.visible)
  const hasPayment = useSession(s => s.user?.hasPayment)
  const setRetryText = useChat(s => s.setRetryText)

  const [text, setText] = useState('')

  const action = useChat(s => {
    const messageId = s.messageIds.at(-1)
    if (!messageId) return
    return s.data[messageId].message.action
  })

  const showAccessAction = (action === 'access' && !user?.hasAccess)
    || (messageCount === 0 && hasPayment)

  useEffect(() => {
    if (!retryText) return

    setText(currentText => currentText || retryText)
    setRetryText(null)
  }, [retryText])

  return (
    <form class={styles.root}>
      {showAccessAction
        ? (
          <Motion class={styles.paywal}>
            <ChatOfferV2 />
          </Motion>
        )
        : (
          <form
            class={styles.form}
            onSubmit={async e => {
              e.preventDefault()
              metrikaGoal('chat_submit_message')
              chatSubmit(text)
              setText('')
            }}
          >
            <button
              type='button'
              class={styles.menuBtn}
              onClick={() => {
                metrikaGoal('menu_click_btn')

                if (chatMenuVisible) {
                  hideChatMenu()
                }
                else {
                  setGroupId(undefined)
                  showChatMenu()
                }
              }}
              disabled={processing}
            >
              {chatMenuVisible ? <CloseSvg /> : <MenuBtnSvg />}
            </button>

            <input
              type='text'
              class={styles.input}
              inputmode='text'
              autocomplete='off'
              placeholder='Твой вопрос...'
              disabled={processing}
              value={text}
              onChange={e => {
                setText(e.currentTarget.value)
              }}
              onInput={e => {
                setText(e.currentTarget.value)
              }}
              onFocus={() => {
                hideChatMenu()
              }}
            />

            <button
              type='submit'
              class={styles.submit}
              disabled={!text || processing}
            >
              <ArrowRightSvg
                strokeWidth={1.5}
              />
            </button>

            <ChatMenu
              bot={props.bot ?? 'zoe'}
            />
          </form>
        )}
    </form>
  )
}
